/* eslint-disable no-param-reassign */
import produce from 'immer';
import initialState from './initialState';
var sampleLoadingTablesError = produce(function (draft, action) {
  draft.meta.loading = false;
  draft.meta.initialLoadPending = false;
  draft.meta.error = action.payload.error;
}, initialState);
export default sampleLoadingTablesError;